'use client';

import type { RefObject } from 'react';

import { ContactSection } from '~/landing/app/(polyseme)/polyseme/sections';
import { FloatingCta } from '~/landing/core/simulator/floating-cta';

import {
  ContentSection,
  DotCarousel,
  HeroSection,
  PresentationSection,
} from './components';

type ClientProps = {
  contactCardRef?: RefObject<HTMLDivElement | null>;
  goToDemo: () => void;
};

export const Client = ({ contactCardRef, goToDemo }: ClientProps) => {
  return (
    <div className="mx-auto w-full space-y-6 px-4 py-14 md:max-w-screen-xl">
      <HeroSection goToDemo={goToDemo} />
      <ContentSection />
      <PresentationSection />
      <DotCarousel goToDemo={goToDemo} />
      <FloatingCta>
        <div
          ref={contactCardRef}
          className="mx-auto lg:max-w-screen-2xl lg:px-8"
        >
          <ContactSection defaultRequestType="simulator" landingType="germen" />
        </div>
      </FloatingCta>
    </div>
  );
};
